import React, { Component } from "react";
import ImageControlModalView from "./ImageControlModalView";
import createApiService from "../../../../network";
import axios from "axios";
import { normalize } from "normalizr";
import { block as blockSchema } from "../../../../schemas";

class ImageControlModalContainer extends Component {
    constructor(props) {
        super(props);

        this.api = createApiService(axios);
    }

    async onImageControlChanged() {
        const blocks = await this.api.getCeremonyBlocks(this.props.ceremonyId);
        const { entities: newBlockEntities } = normalize(blocks.data.data, [
            blockSchema,
        ]);
        this.props.updateStoreEntities(newBlockEntities);
        this.props.hideModal();
    }

    render() {
        return (
            <ImageControlModalView
                hideModal={this.props.hideModal}
                isVisible={true}
                blockId={this.props.blockId}
                manualImageControl={this.props.manualImageControl}
                ceremonyId={this.props.ceremonyId}
                onImageControlChanged={this.onImageControlChanged.bind(this)}
            />
        );
    }
}

export default ImageControlModalContainer;
